<template>
  <v-container fluid>
    <static-page
        :page-tag="pageTag" />
    <v-row align-center justify="center">
      <!--  -->
    </v-row>
  </v-container>
</template>

<script>
  import StaticPage from '@/components/reused/staticPages/StaticPage.vue'
  import { STATIC_PAGES_TAGS } from '@/constants/business'

  export default {
    name: 'Main',
    components: {
      StaticPage
    },
    computed: {
      pageTag () {
        return this.isAdmin
          ? STATIC_PAGES_TAGS.STATIC_MAIN_ADMIN
          : STATIC_PAGES_TAGS.STATIC_MAIN
      }
    }
  }
</script>
